import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Input,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  Button,
  Label,
} from "ksc-portal-common-components/shadcn"
import { Switch, Route, Redirect } from "react-router-dom"
import { CognitoUserPool, CookieStorage } from "amazon-cognito-identity-js"
import { makeUnauthGetRequest } from "../../../utils/lambda/unauthRequests"
import {
  USER_POOL,
  APPLICATION_CLIENT_ID,
} from "../../SessionManagement/constants"
import Legal from "../../Legal"
import LoginHeroVideo from "../../Login/authViews/LoginHeroVideo"
import { SSO_LOGIN_TITLE } from "../../Login/constants"

const SSO_LEGAL_CONST = "sso/login/legal"

const Login = ({
  protocols,
  history,
  cookies,
  renderApplication,
  storeUserPool,
}) => {
  const [email, setEmail] = useState("")
  const urlParams = new URLSearchParams(history.location.search)
  const referURL = urlParams.get("refer")

  if (protocols === null) return null

  const onFailure = () => {
    history.push(`/login${history.location.search}`)
    makeUnauthGetRequest({
      url: "/foundation_v1/sign-in-details",
      onFailure: (error) => {
        console.error(error)
        renderApplication()
        history.push("/error/500")
      },
      onSuccess: ({ cognito_app_client_id, cognito_user_pool_id }) => {
        const UserPoolId = cognito_user_pool_id
        const ClientId = cognito_app_client_id
        const domain = window.location.host
        const userPool = new CognitoUserPool({
          UserPoolId,
          ClientId,
          Storage: new CookieStorage({ domain }),
        })

        cookies.set(USER_POOL, cognito_user_pool_id, { path: "/" })
        cookies.set(APPLICATION_CLIENT_ID, cognito_app_client_id, {
          path: "/",
        })
        const loggedOut = true
        storeUserPool(userPool, loggedOut)
        renderApplication()
        history.push(`/login${history.location.search}`)
      },
    })
  }

  const onSubmit = (e) => {
    e.preventDefault()
    makeUnauthGetRequest({
      url: `/iam_v1/sso/details/${email.toLowerCase()}${
        referURL ? `?refer=${referURL}` : ""
      }`,
      onSuccess: ({ authorisation_url }) => {
        const authorisationUrl = new URL(authorisation_url)
        const stateParam = authorisationUrl.searchParams.get("state")
        const stateParamWithRefer = `${stateParam},${referURL || "/"}`
        if (stateParam)
          authorisationUrl.searchParams.set("state", stateParamWithRefer)
        window.location.replace(authorisationUrl)
      },
      onFailure,
    })
  }

  const renderPrivacyPolicy = () => {
    history.push(`/${SSO_LEGAL_CONST}`)
  }

  return protocols.length === 0 ? (
    <Redirect to={`/login${history.location.search}`} />
  ) : (
    <Switch>
      <Route path="/sso/login" exact>
        <div className="relative flex items-center justify-center min-h-screen overflow-hidden">
          <LoginHeroVideo renderPrivacyPolicy={renderPrivacyPolicy}>
            <Card className="w-full lg:w-1/2 max-w-sm backdrop-blur-sm bg-background/80">
              <>
                <CardHeader>
                  <CardTitle className="text-2xl font-medium text-foreground">
                    Welcome to{" "}
                    {document.title === "Kaizen Hub"
                      ? "the Hub"
                      : document.title}
                  </CardTitle>
                  <CardDescription>{SSO_LOGIN_TITLE}</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <form onSubmit={onSubmit}>
                    <div className="space-y-4">
                      <div className="space-y-2">
                        <Label htmlFor="email">Email</Label>
                        <Input
                          id="email"
                          type="email"
                          placeholder="m@example.com"
                          value={email}
                          onChange={({ target: { value } }) => setEmail(value)}
                          data-testid="email-input"
                        />
                      </div>
                      <Button
                        type="submit"
                        variant="default"
                        className="w-full"
                        data-testid="submit-button"
                      >
                        Login
                      </Button>
                    </div>
                  </form>
                </CardContent>
              </>
            </Card>
          </LoginHeroVideo>
        </div>
      </Route>
      <Route path={`/${SSO_LEGAL_CONST}`}>
        <Legal
          ssoEnabled
          legalConst={SSO_LEGAL_CONST}
          history={history}
          loggedIn={false}
        />
      </Route>
    </Switch>
  )
}

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
  }).isRequired,
  protocols: PropTypes.arrayOf(PropTypes.string),
  cookies: PropTypes.shape({
    set: PropTypes.func,
  }).isRequired,
  renderApplication: PropTypes.func.isRequired,
  storeUserPool: PropTypes.func.isRequired,
}

Login.defaultProps = {
  protocols: null,
}

export default Login
